import Img from "@/components/Img";
import { fmtDate } from "@/lib/api";
import { useT, useLoc } from "@/lib/i18n";
import { Countdown } from "@/components/customer/Countdown";

export const COLORS = { blue: "#1F5F8B", green: "#2F7A54", brown: "#8A5A3B", red: "#B91C1C", orange: "#E2711D", dark: "#1C1917" };
const rgba = (hex, a) => `rgba(${parseInt(hex.slice(1, 3), 16)},${parseInt(hex.slice(3, 5), 16)},${parseInt(hex.slice(5, 7), 16)},${a})`;

const GRAD = {
  left: (h) => `linear-gradient(90deg, ${rgba(h, 0.96)} 0%, ${rgba(h, 0.8)} 38%, ${rgba(h, 0)} 72%)`,
  right: (h) => `linear-gradient(270deg, ${rgba(h, 0.96)} 0%, ${rgba(h, 0.8)} 38%, ${rgba(h, 0)} 72%)`,
  center: (h) => `radial-gradient(ellipse at center, ${rgba(h, 0.88)} 0%, ${rgba(h, 0.55)} 55%, ${rgba(h, 0.25)} 100%)`,
  bottom: (h) => `linear-gradient(0deg, ${rgba(h, 0.96)} 0%, ${rgba(h, 0.7)} 40%, ${rgba(h, 0)} 75%)`,
};
const POS = {
  left: "items-start justify-center text-left pr-[38%]",
  right: "items-end justify-center text-right pl-[38%]",
  center: "items-center justify-center text-center px-[12%]",
  bottom: "items-start justify-end text-left",
};

export default function BannerArt({ c, hero = false, i = 0 }) {
  const t = useT();
  const loc = useLoc();
  const layout = c.layout || "left";
  const hex = COLORS[c.color] || Object.values(COLORS)[i % 3];
  const img = hero ? c.hero_image || c.image || c.photo : c.image || c.photo;
  const big = hero ? "text-3xl sm:text-5xl lg:text-6xl" : "text-xl sm:text-3xl";
  return (
    <div className="relative h-full w-full overflow-hidden text-white" style={{ backgroundColor: hex }} data-testid={hero ? "banner-hero" : "banner-card"}>
      {img && <Img src={img} size={hero ? "lg" : "md"} eager={hero} alt="" className="absolute inset-0 h-full w-full object-cover" />}
      {img && <div className="absolute inset-0" style={{ background: GRAD[layout](hex) }} />}
      <div className={`relative z-10 flex h-full flex-col gap-0.5 [&>*]:shrink-0 sm:gap-1 ${hero ? "p-6 sm:p-12" : "p-4 pl-12 sm:p-5 sm:pl-14"} ${POS[layout]}`}>
        {loc(c, "badge") && <span className={`mb-0.5 rounded-full bg-black/35 px-2.5 py-0.5 font-bold uppercase tracking-wide backdrop-blur-sm ${hero ? "text-xs" : "text-[10px]"}`}>{loc(c, "badge")}</span>}
        <p className={`font-heading font-extrabold leading-tight drop-shadow ${hero ? "line-clamp-2 text-2xl sm:text-4xl" : "line-clamp-1 text-sm sm:text-lg"}`}>{loc(c, "title")}</p>
        {loc(c, "subtitle") && <p className={`font-semibold opacity-95 drop-shadow ${hero ? "line-clamp-2 text-base sm:text-xl" : "line-clamp-1 text-[11px] sm:text-sm"}`}>{loc(c, "subtitle")}</p>}
        {c.show_discount !== false && c.max_discount > 0 && (
          <p className={`font-heading font-black leading-none tracking-tight drop-shadow ${big}`}>
            <span className="mr-1 text-sm font-bold sm:text-base">{t("Hingga")}</span>{Math.round(c.max_discount)}%<span className="ml-1 text-sm sm:text-lg">off</span>
          </p>
        )}
        {c.end_date && (c.kind === "flash_sale" ? <span className="mt-1"><Countdown end={c.end_date} testid={`featured-countdown-${c.id}`} /></span>
          : <span className="mt-1 rounded-full bg-white/20 px-2.5 py-0.5 text-[11px] font-semibold backdrop-blur-sm sm:text-xs">{t("Pesan sampai {d}", { d: fmtDate(c.end_date, "d MMM yyyy") })}</span>)}
        {loc(c, "terms") && <p className={`opacity-80 ${hero ? "mt-1 text-xs" : "text-[10px]"}`}>{loc(c, "terms")}</p>}
      </div>
    </div>
  );
}
